
import { defineComponent, reactive, watch } from "vue";
import Agora from "@/assets/common/Agora";
import store from "@/store";
import router from "@/router";

const DEFAULT = config.agoraDefault;

type FormInline = {
  appid: string;
  token: string;
  channel: string;
};

export default defineComponent({
  name: "Home",
  setup() {
    const form: FormInline = reactive({
      appid: DEFAULT.appid,
      token: DEFAULT.token,
      channel: DEFAULT.channel
    });

    const rules = {
      appid: { required: true, message: "Appid is required", trigger: "blur" },
      token: { required: true, message: "Token is required", trigger: "blur" },
      channel: {
        required: true,
        message: "Channel is required",
        trigger: "blur"
      }
    };

    store.commit("setChannel", form.channel);
    watch(
      () => form.channel,
      nv => {
        store.commit("setChannel", nv);
      }
    );

    const joinChannel = function() {
      const agora = new Agora({
        appid: form.appid,
        token: form.token,
        channel: form.channel,
        handleSuccess: uid => {
          window.logger.log("info", `join channel success, uid: ${uid}`);
        },
        handleError: err => {
          window.logger.log("info", `join channel failture, err: ${err}`);
        }
      });

      window.agora = agora;
      router.push("channel");
    };

    return { form, rules, joinChannel };
  }
});
